import { useMemo } from 'react';

interface FormData {
  [key: string]: string;
}

export const useFormValidation = (
  orderInformationData: FormData,
  shippingData: FormData,
  productsCount: number
) => {
  const isFormValid = useMemo(() => {
    // Validar campos requeridos de OrderInformation
    const isOrderInfoValid =
      orderInformationData.reference?.trim() !== '' &&
      orderInformationData.store?.trim() !== '' &&
      orderInformationData.paymentMethod?.trim() !== '';

    // Validar campos requeridos de ShippingData
    const isShippingValid =
      shippingData.customerName?.trim() !== '' &&
      shippingData.customerPhone?.trim() !== '' &&
      shippingData.address1?.trim() !== '' &&
      shippingData.postalCode?.trim() !== '' &&
      shippingData.city?.trim() !== '' &&
      shippingData.country?.trim() !== '';

    // Validar que haya al menos un producto
    const hasProducts = productsCount > 0;

    return isOrderInfoValid && isShippingValid && hasProducts;
  }, [orderInformationData, shippingData, productsCount]);

  return { isFormValid };
};
